import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';

export const OBJECT_FRAGMENT = gql`
  fragment ObjectFragment on Object {
    id
    name
    objectNumber
    transactionType
    submission
    tenderNr
    tenderName
    createdByManufacturer
    address {
      ...AddressFragment
    }
    additionalAddresses {
      id
      salutation
      firstName
      lastName
      email
      phone
      fax
      website
      contactType
      address {
        ...AddressFragment
      }
      companyName
    }
  }
  ${ADDRESS_FRAGMENT}
`;
